import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  me: () => api.get('/auth/me'),
  changePassword: (data) => api.post('/auth/change-password', data),
  register: (userData) => api.post('/auth/register', userData),
};

export const userAPI = {
  getAll: () => api.get('/users'),
  getById: (id) => api.get(`/users/${id}`),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
  getBillingSummary: (id, params) => api.get(`/users/${id}/billing-summary`, { params }),
};

export const projectAPI = {
  getAll: (params) => api.get('/projects', { params }),
  getById: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  delete: (id) => api.delete(`/projects/${id}`),
  getHoursSummary: (id, params) => api.get(`/projects/${id}/hours-summary`, { params }),
};

export const timesheetAPI = {
  getAll: (params) => api.get('/timesheets', { params }),
  getById: (id) => api.get(`/timesheets/${id}`),
  getCurrentWeek: () => api.get('/timesheets/current/me'),
  create: (data) => api.post('/timesheets', data),
  submit: (id) => api.post(`/timesheets/${id}/submit`),
  review: (id, data) => api.post(`/timesheets/${id}/review`, data),
  unlock: (id) => api.post(`/timesheets/${id}/lock`, { lock: false }),
  lock: (id, lock) => api.post(`/timesheets/${id}/lock`, { lock }),
  getReportSummary: (params) => api.get('/timesheets/reports/summary', { params }),
};

export default api;
